module.exports = __webpack_public_path__ + "static/media/brain.f6857965.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logo/brain.png
// module id = 51
// module chunks = 0